// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--pV09J","headerMobileOpen":"Header-module--headerMobileOpen--3OJ44"};